import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Menu,
  Select,
  Table,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { useDebouncedState, useHotkeys } from "@mantine/hooks";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { _localization } from "../../../config/location";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import {
  IconCalendar,
  IconCheck,
  IconEye,
  IconHandClick,
  IconPhone,
  IconSearch,
  IconStatusChange,
  IconUser,
} from "@tabler/icons-react";
import { DatePickerInput } from "@mantine/dates";
import {
  changeSearchValue,
  getValueById,
} from "../../../_base/helper/FunctionHelper";
import {
  keySearchPurchaseRegistrationList,
  repositoryCart,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { AvatarUtils } from "../../../common/ColorByName/AvatarUtils";
import { modals } from "@mantine/modals";
import UpdateCollectionFormWeb from "./UpdateCollectionFormWeb";
import { green } from "../../../const/variables";

const PurchaseRegistrationList = () => {
  const dataUser = JSON.parse(localStorage.getItem("userLoginHeader") ?? "");
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const _searchJson = sessionStorage.getItem(keySearchPurchaseRegistrationList)
    ? JSON.parse(
        sessionStorage.getItem(keySearchPurchaseRegistrationList) ?? ""
      )
    : null;
  const [search, setSearch] = useState<any>({
    FromDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.FromDate
        : new Date(
            new Date(
              new Date(new Date().setDate(new Date().getDate() - 9)).setHours(
                0,
                0,
                0,
                0
              )
            ).getTime() +
              7 * 60 * 60 * 1000
          )?.toISOString(),
    ToDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.ToDate
        : new Date(
            new Date(
              new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                0,
                0,
                0,
                0
              )
            ).getTime() +
              7 * 60 * 60 * 1000
          )?.toISOString(),
    HandleEmpId:
      _searchJson && checkedPinSearch ? _searchJson?.HandleEmpId : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );
  const [phoneNumber, setPhoneNumber] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.phoneNumber : "",
    300
  );
  const [deleteViewStatus, setDeleteViewStatus] = useState<boolean>(false);

  const [dataEmployee, setDataEmployee] = useState<ComboboxItem[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <Badge
            color={
              renderedCellValue === "TIEP_NHAN"
                ? "yellow"
                : renderedCellValue === "DA_XU_LY"
                ? "teal"
                : "blue"
            }
          >
            {renderedCellValue === "TIEP_NHAN"
              ? "Tiếp nhận"
              : renderedCellValue === "DA_XU_LY"
              ? "Đã xử lý"
              : "Chưa xử lý"}
          </Badge>
        ),
      },
      {
        accessorKey: "fullName",
        header: "Tên khách hàng",
        Cell: ({ renderedCellValue }) => (
          <AvatarUtils value={renderedCellValue?.toString() ?? ""} />
        ),
      },
      {
        accessorKey: "mobile",
        header: "Số điện thoại",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "productCode",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "productName",
        header: "Sản phẩm",
        Cell: ({ row }) => {
          const [hovered, setHovered] = React.useState(false);
          return (
            <Tooltip label="Xem thông tin sản phẩm" openDelay={750}>
              <Text
                fw={500}
                size="12.5px"
                c={hovered ? "#1971c2" : "black"}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={() =>
                  window.open(`https://hacom.vn/${row.original.productLink}`)
                }
                style={{ width: "fit-content" }}
              >
                {row.original.productName}
              </Text>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "empId",
        header: "Người tiếp nhận xử lý",
        size: 225,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {getValueById(
                renderedCellValue?.toString() ?? "",
                dataEmployee,
                "label"
              )}
            </Text>
          ) : (
            <Text fw={500} size="12.5px">
              Chưa tiếp nhận
            </Text>
          ),
      },
      {
        accessorKey: "attribute1",
        header: "Thời gian tiếp nhận",
        Cell: ({ renderedCellValue }: any) =>
          renderedCellValue ? (
            <>
              {renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}
            </>
          ) : (
            <Text fw={500} size="12.5px">
              Chưa tiếp nhận
            </Text>
          ),
      },
      {
        accessorKey: "creationDate",
        header: "Thời gian tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "description",
        header: "Ghi chú",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnActions: false,
        enableSorting: false,
        enableColumnFilter: false,
        enableResizing: false,
        enableClickToCopy: false,
        size: 70,
        Cell: ({ row }) => {
          const [hovered, setHovered] = React.useState(false);

          return (
            <Flex align={"center"} gap={"md"}>
              {row.original.status === "CHUA_XU_LY" || !row.original.status ? (
                <Tooltip label={"Tiếp nhận"}>
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="yellow"
                    onClick={() => {
                      handleApprove(row.original.id);
                    }}
                  >
                    <IconHandClick size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              ) : row.original.status === "TIEP_NHAN" ? (
                <Tooltip label={"Đã xử lý"}>
                  <ActionIcon
                    variant="light"
                    aria-label="Settings"
                    color="green"
                    onClick={() => {
                      modalsUpdate(row.original.id, "DA_XU_LY");
                    }}
                    disabled={row.original.empId !== dataUser.id}
                  >
                    <IconCheck size={20} stroke={1.5} />
                  </ActionIcon>
                </Tooltip>
              ) : (
                <></>
              )}

              <Menu position="left">
                <Menu.Target>
                  <Tooltip label="Xem chi tiết">
                    <ActionIcon
                      variant="light"
                      aria-label="Settings"
                      color="blue"
                      size={"md"}
                      p={2}
                    >
                      <IconEye stroke={1.5} />
                    </ActionIcon>
                  </Tooltip>
                </Menu.Target>
                <Menu.Dropdown>
                  <Table variant="vertical" withTableBorder>
                    <Table.Tbody>
                      <Table.Tr>
                        <Table.Th w={110} bg={"#F8F9FA"}>
                          Họ tên
                        </Table.Th>
                        <Table.Td>{row.original.fullName}</Table.Td>
                      </Table.Tr>

                      <Table.Tr>
                        <Table.Th w={110} bg={"#F8F9FA"}>
                          Email
                        </Table.Th>
                        <Table.Td>{row.original.email}</Table.Td>
                      </Table.Tr>

                      <Table.Tr>
                        <Table.Th w={110} bg={"#F8F9FA"}>
                          Điện thoại
                        </Table.Th>
                        <Table.Td>{row.original.mobile}</Table.Td>
                      </Table.Tr>

                      <Table.Tr>
                        <Table.Th w={110} bg={"#F8F9FA"}>
                          Mã sản phẩm
                        </Table.Th>
                        <Table.Td>{row.original.productCode}</Table.Td>
                      </Table.Tr>

                      <Table.Tr
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                        onClick={() =>
                          window.open(
                            `https://hacom.vn/${row.original.productLink}`
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <Table.Th w={110} bg={"#F8F9FA"}>
                          Sản phẩm
                        </Table.Th>
                        <Table.Td c={hovered ? "blue" : "black"}>
                          {row.original.productName}
                        </Table.Td>
                      </Table.Tr>

                      <Table.Tr>
                        <Table.Th w={110} bg={"#F8F9FA"}>
                          Thời gian tạo
                        </Table.Th>
                        <Table.Td>
                          {row.original.creationDate
                            ? formatDateTransfer(row.original.creationDate)
                            : ""}
                        </Table.Td>
                      </Table.Tr>
                    </Table.Tbody>
                  </Table>
                </Menu.Dropdown>
              </Menu>
            </Flex>
          );
        },
      },
    ],
    [dataEmployee]
  );

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  const modalsUpdate = (id: number, status: string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Cập nhật trạng thái</Title>
        </>
      ),

      size: "auto",
      children: (
        <UpdateCollectionFormWeb
          id={id}
          status={status}
          onClose={setDeleteViewStatus}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async (noti?: string) => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblCollectionForm/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (
          value &&
          ((typeof value === "string" && value.length > 0) ||
            (Array.isArray(value) && value.length > 0))
        ) {
          params.append(key, String(value));
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      if (phoneNumber.length > 0) {
        url += `&Phone=${phoneNumber}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryCart.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
        if (noti) {
          table.resetRowSelection();
        }
      }

      if (noti && noti.length > 0) {
        NotificationExtension.Success(noti);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        keySearchPurchaseRegistrationList,
        JSON.stringify({
          ...search,
          keySearch: keySearch,
          phoneNumber: phoneNumber,
        })
      );
    }
  };

  const fetchDataEmployee = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-list?DepartmentId=1293&Skip=0&Take=100"
    );

    if (res && res.success) {
      const result = res.data
        ?.filter((item: any) => item.id && item.code && item.fullname)
        ?.map((item: any) => ({
          label: `${item.code} - ${item.fullname}`,
          value: item.id?.toString(),
        }));

      setDataEmployee(result);
    }
  };

  const handleApprove = async (id: number) => {
    const res = await repositoryPos.post<MessageResponse<any>>(
      `/api/v1/CollectionFormWeb/update?Id=${id}&Status=TIEP_NHAN&EmpId=${dataUser?.id}`
    );

    if (res && res.success) {
      NotificationExtension.Success("Tiếp nhận thành công !");

      setTimeout(() => {
        fetchData();
      }, 1000);
    }
  };

  useEffect(() => {
    fetchDataEmployee();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pagination, deleteViewStatus]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-numbers", "status"],
        right: ["action"],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    // mantineToolbarAlertBannerProps: isError
    //   ? { color: "red", children: "Lỗi tải dữ liệu !" }
    //   : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate ?? "")
                  : null
              }
              maxDate={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "FromDate",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              value={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate ?? "")
                  : null
              }
              minDate={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e ? formatDateNotTimeZone(e ?? "") : "",
                  "ToDate",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập số điện thoại"
              type="number"
              defaultValue={phoneNumber}
              onChange={(e) => setPhoneNumber(e.currentTarget.value)}
              leftSection={<IconPhone color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Trạng thái"
              data={[
                { label: "Chưa xử lý", value: "CHUA_XU_LY" },
                { label: "Tiếp nhận", value: "TIEP_NHAN" },
                { label: "Đã xử lý", value: "DA_XU_LY" },
              ]}
              leftSection={<IconStatusChange color="#15aabf" />}
              clearable
              onChange={(e) =>
                changeSearchValue(e ? e : "", "Status", setSearch)
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Người xử lý"
              data={dataEmployee}
              leftSection={<IconUser color="#15aabf" />}
              value={String(search?.HandleEmpId)}
              searchable
              clearable
              onChange={(e) =>
                changeSearchValue(e ? e : "", "HandleEmpId", setSearch)
              }
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default PurchaseRegistrationList;
